import { activateLocale } from "@/i18n";
import type { AppLocale } from "@/i18n/locales";
import { storeLocale } from "@/i18n/persistence";
import { localeAtom } from "@/state/locale.state";
import { useAtom } from "jotai";

export function useChangeLanguage() {
  const [locale, setLocale] = useAtom(localeAtom);

  return async function changeLanguage(next: AppLocale, store?: boolean) {
    if (next === locale) return;
    setLocale(next);
    if (store) {
      storeLocale(next);
    }
    await activateLocale(next);
  };
}
